import React from 'react';
import { Link } from "react-router-dom";

export default class ChangeLogComponent extends React.Component {
   render() {
      return (
         <div className="change-log-view">
            <h1>Change Log</h1>
            <Link className="link-button" to={{ pathname: '/', force_update: true }}>return to home</Link>
            <p>
               This is a list of changes made to the game, in reverse chronological order.
               Please note that this is a work in progress and not all changes may be listed.
               If you have any questions or suggestions, please feel free to contact us.
            </p>

            <h2>Version w1 (2025-06-08)</h2>
            <ul>
               <li>feature: Reworked shipyard:
                  <ul>
                     <li>ship construction limit queue size</li>
                     <li>showing cost of a ship design</li>
                     <li>ship queue issues (crash_03.png)</li>
                  </ul>
               </li>
               <li>feature: Better cost/time scaling for all buildings
                  <ul>
                     <li>less much money</li>
                     <li>ship design(+construction) takes more time</li>
                     <li>bug: building construction shows total energy consumption for the next level of a building, not how much more it will take</li>
                     <li>production buildings always cost the same</li>
                  </ul>
               </li>
               <li>feature: Building info page shows correct information</li>
               <li>feature: taxes for workers: more taxes == more money, but less worker production.</li>
               <li>feature: ais</li>
               <li>fix: input text validation: no more invisible characters.
                  <ul>
                     <li>Places of concern: [player_name, faction_name, faction_description, chat_message, chat_content, planet_name, ship_name, fleet_name]</li>
                     <li>Two accounts with the same name (crash_01.png)</li>
                     <li>Nice error messages in GUI, when trying to send a malformed chat reply (crash_00.txt)</li>
                     <li>Compose message send button is no longer ass ugly</li>
                  </ul>
               </li>
               <li>fix: time travel bug in starting planets (crash_02.png)</li>
               <li>feature: indicator if there is no research in queue in menu (red)</li>
            </ul>
         </div >
      );
   }
}
